// API_URL will be replaced in the build step

export const apiUrl = 'API_URL' + '/.netlify/functions'
